"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluate = void 0;
const Actions = __importStar(require("../actions"));
const closure_1 = require("../closure");
const env_1 = require("../env");
const Errors = __importStar(require("../errors"));
const Values = __importStar(require("../value"));
function evaluate(env, core) {
    switch (core["@kind"]) {
        case "Var": {
            const value = (0, env_1.envLookupValue)(env, core.name);
            if (value === undefined) {
                throw new Errors.EvaluationError(`[evaluate] undefined variable name: ${core.name}`);
            }
            return value;
        }
        case "PatternVar": {
            const value = (0, env_1.envLookupValue)(env, core.name);
            if (value === undefined) {
                throw new Errors.EvaluationError(`[evaluate] undefined pattern variable name: ${core.name}`);
            }
            return value;
        }
        case "Pi": {
            return Values.Pi(evaluate(env, core.argType), (0, closure_1.ClosureSimple)(env, core.name, core.retType));
        }
        case "PiImplicit": {
            return Values.PiImplicit(evaluate(env, core.argType), (0, closure_1.ClosureSimple)(env, core.name, core.retType));
        }
        case "Fn": {
            return Values.Fn((0, closure_1.ClosureSimple)(env, core.name, core.ret));
        }
        case "FnImplicit": {
            return Values.FnImplicit((0, closure_1.ClosureSimple)(env, core.name, core.ret));
        }
        case "Ap": {
            return Actions.doAp(evaluate(env, core.target), evaluate(env, core.arg));
        }
        case "ApImplicit": {
            return Actions.doApImplicit(evaluate(env, core.target), evaluate(env, core.arg));
        }
        case "Sigma": {
            return Values.Sigma(evaluate(env, core.carType), (0, closure_1.ClosureSimple)(env, core.name, core.cdrType));
        }
        case "Cons": {
            return Values.Cons(evaluate(env, core.car), evaluate(env, core.cdr));
        }
        case "Car": {
            return Actions.doCar(evaluate(env, core.target));
        }
        case "Cdr": {
            return Actions.doCdr(evaluate(env, core.target));
        }
        case "Quote": {
            return Values.Quote(core.data);
        }
        case "ClazzNull": {
            return Values.ClazzNull(core.name);
        }
        case "ClazzCons": {
            return Values.ClazzCons(core.propertyName, evaluate(env, core.propertyType), (0, closure_1.ClosureSimple)(env, core.localName, core.rest), core.name);
        }
        case "ClazzFulfilled": {
            const propertyType = evaluate(env, core.propertyType);
            const property = evaluate(env, core.property);
            env = (0, env_1.EnvCons)(core.propertyName, property, env);
            const rest = evaluate(env, core.rest);
            if (!Values.isClazz(rest)) {
                throw new Errors.EvaluationError([
                    `[evaluate] during ClazzFulfilled, expect the rest to be Clazz`,
                    `  rest["@kind"]: ${rest["@kind"]}`,
                ].join("\n"));
            }
            return Values.ClazzFulfilled(core.propertyName, propertyType, property, rest, core.name);
        }
        case "Objekt": {
            const properties = Object.fromEntries(Object.entries(core.properties).map(([name, core]) => [
                name,
                evaluate(env, core),
            ]));
            return Values.Objekt(properties);
        }
        case "Dot": {
            return Actions.doDot(evaluate(env, core.target), core.name);
        }
        case "Replace": {
            return Actions.doReplace(evaluate(env, core.target), evaluate(env, core.motive), evaluate(env, core.base));
        }
    }
}
exports.evaluate = evaluate;
//# sourceMappingURL=evaluate.js.map